import * as React from "react";
import { SVGProps } from "react";
export const MultiChevronUpDownIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask
            id="mask0_32817_8365"
            style={{
                maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={20}
            height={20}
        >
            <rect width={20} height={20} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_32817_8365)">
            <path
                d="M10.0001 14.875L11.7899 13.0852C11.9439 12.9312 12.1216 12.8542 12.323 12.8542C12.5244 12.8542 12.7015 12.9306 12.8542 13.0833C13.007 13.2361 13.0834 13.4132 13.0834 13.6146C13.0834 13.816 13.0077 13.9926 12.8563 14.1444L10.5297 16.4788C10.4541 16.5547 10.3722 16.6085 10.2838 16.64C10.1955 16.6717 10.1009 16.6875 10.0001 16.6875C9.89925 16.6875 9.80466 16.6717 9.71633 16.64C9.628 16.6085 9.54605 16.5547 9.4705 16.4788L7.14383 14.1444C6.99244 13.9926 6.92022 13.816 6.92716 13.6146C6.93411 13.4132 7.01397 13.2361 7.16675 13.0833C7.31953 12.9306 7.49661 12.8542 7.698 12.8542C7.89939 12.8542 8.07626 12.9312 8.22862 13.0852L10.0001 14.875ZM10.0001 5.125L8.21029 6.91479C8.05626 7.06882 7.87855 7.14583 7.67716 7.14583C7.47578 7.14583 7.29869 7.06944 7.14591 6.91667C6.99314 6.76389 6.91675 6.58681 6.91675 6.38542C6.91675 6.18403 6.99244 6.00743 7.14383 5.85563L9.4705 3.52125C9.54605 3.44528 9.628 3.39153 9.71633 3.36C9.80466 3.32833 9.89925 3.3125 10.0001 3.3125C10.1009 3.3125 10.1955 3.32833 10.2838 3.36C10.3722 3.39153 10.4541 3.44528 10.5297 3.52125L12.8563 5.85563C13.0077 6.00743 13.0834 6.18056 13.0834 6.375C13.0834 6.56944 13.007 6.74306 12.8542 6.89583C12.7015 7.04861 12.5244 7.125 12.323 7.125C12.1216 7.125 11.9439 7.04882 11.7899 6.89646L10.0001 5.125Z"
                fill="currentColor"
            />
        </g>
    </svg>
);
MultiChevronUpDownIcon.displayName = "MultiChevronUpDownIcon";
